<script>
    import LeftPanel from '@/components/container/LeftPanel.vue';
    import RightContainer from '@/components/container/RightContainer.vue';
    import MainConainer from '@/components/container/MainContainer.vue';

    import ButtonAnyNew from '@/components/left-panel/any-button/ButtonAnyNew.vue';
    import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

    import PromptList from '@/components/page-chat-gpt-edit/PromptList.vue';
    import PromptAdd from '@/components/page-chat-gpt-edit/prompt-add/PromptAdd.vue';
    import PromptEdit from '@/components/page-chat-gpt-edit/prompt-edit/PromptEdit.vue';

    export default {
        components: {
            LeftPanel: LeftPanel,
            RightContainer: RightContainer,
            MainConainer: MainConainer,
            
            ButtonAnyNew: ButtonAnyNew,
            ButtonReturn: ButtonReturn,

            PromptList: PromptList,
            PromptAdd: PromptAdd,
            PromptEdit: PromptEdit,
        },
        async mounted() {
            this.$store.commit('IS_LOAD', true);
            this.$store.dispatch('CHECK_PROMPTS');
            this.$store.commit('IS_LOAD', false);
        },
        methods: {
            async togglePromptAdd() {
                const showAdd = this.$store.getters.IS_SHOW_PROMPT_ADD;
                this.$store.commit('IS_SHOW_PROMPT_ADD', !showAdd);
                await this.$store.dispatch('CHECK_PROMPT_ADD');
            }
        }
    }
</script>


<template>
    <PromptAdd />
    <PromptEdit />
    
    <MainConainer>
        <LeftPanel>
            <ButtonAnyNew 
                title="New Prompt"
                :method="togglePromptAdd"
            />
            <hr class="left-separator">
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <PromptList />
        </RightContainer>
    </MainConainer>
</template>